import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { BatchSignal, TreeSignal } from '@xanadu/signal';
import { Register, DynamicComponent } from '@xanadu/core';
import { BatchContent } from '@xanadu/model';
import { SafeStyle } from '@angular/platform-browser';

@Component({
    selector: 'app-batch-view',
    templateUrl: './batch-view.component.html',
    styleUrls: ['./batch-view.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[style]': 'hostStyle'
    }
})
@Register('batch-view')
export class BatchViewComponent extends DynamicComponent {
    private readonly treeSignal = inject(TreeSignal);
    private readonly batchSignal = inject(BatchSignal);

    view = signal<any>(undefined);

    hostStyle?: SafeStyle;

    batchContent?: BatchContent;

    constructor() {
        super();

        effect(() => {
            const model = this.model();
            if (model?.hostStyle) {
                this.hostStyle = model.hostStyle;
            }
        });

        effect(() => {
            const batch = this.batchSignal.content();

            this.batchContent = batch;
            const child = batch
                ? {
                    component: 'batch-panel',
                    node: batch.content,
                    site: batch.site,
                    custome: batch.custome
                }
                : undefined;
            if (child) {
                this.view.set(child);
            }
        });

        effect(() => {
            const model = this.treeSignal.contentLoad();

            if (model?.batch?.disabled && model.descents?.length) {
                model.descents.forEach((descent: any) => {
                    descent.batch.disabled = true;
                });
            }
            if (model?.batch?.checked) {
                this.batchSignal.on.set(model);
            }
        });
    }
}
